'use client'

import { memo } from 'react'

import { ErrorFallback } from '@components/Layout/ErrorFallback'
import { type ReportableError } from '@hooks/useReportError'

type GlobalErrorProps = {
  error: ReportableError
  reset: () => void
}

const GlobalError = memo(({ error, reset }: GlobalErrorProps) => (
  <html lang='en'>
    <body className='flex flex-col items-center justify-center min-h-screen text-foreground bg-foreground'>
      <ErrorFallback error={error} reset={reset} source='global-error-boundary' title='Global Error:' />
    </body>
  </html>
))

export default GlobalError
